import {DealerFeature} from '../../../shared/model/api/DealerFeature';
import * as appCustomerInfoActions from '../actions/dealer-detail-auth.action';
import { createReducer, on } from '@ngrx/store';
import * as appDealerDetailActions from '../actions/dealer-detail-auth.action';

export interface AuthAccessState {
    dealerFeatures: Array<DealerFeature>;
    userInfo: any;
    crmInfo: any
    creditData:any;
    customViews:any[];
    salesConsultant:any[];
    salesConsultantResponse:any[];
    myTeams:any[];
    defaultView:any[];
    darkTheme: boolean;
    logView:any[];
}

const AUTH_ACCESS_INITIAL_STATE: AuthAccessState = {
    dealerFeatures: null,
    userInfo: null,
    crmInfo: null,
    creditData:null,
    customViews:[],
    salesConsultant:[],
    salesConsultantResponse: [],
    myTeams:[],
    defaultView: [
        {
            "forSection": "writeup",
            "default": true,
            "viewId": "",
            "viewName": "Default View",
        }
    ],
    darkTheme: false,
    logView: null
};

export const reducer = createReducer(
  AUTH_ACCESS_INITIAL_STATE,
  on(appDealerDetailActions.DealerConfigSuccessAction, (state, { response }) => ({...state, dealerFeatures: response})),
  on(appDealerDetailActions.LoadUserInfoSuccessAction, (state, { response }) => ({...state, userInfo: response})),
  on(appDealerDetailActions.LoadCreditSuccessAction, (state, { response }) => ({...state, creditData: response})),
  on(appDealerDetailActions.LoadCrmInfoSuccessAction, (state, { response }) => ({...state, crmInfo: response})),
  on(appCustomerInfoActions.LoadCustomViewSuccessAction, (state, { response }) => loadCustomView(state, response)),
  on(appCustomerInfoActions.LoadSalesConsultantSuccessAction, (state, { response }) => loadSalesConsultant(state, response)),
  on(appCustomerInfoActions.LoadSalesConsultantFailAction, (state, { error }) => ({...state, salesConsultant: []})),
  on(appDealerDetailActions.LoadSalesConsultantSuccessAction, (state, { response }) => loadSalesConsultant(state, response)),
  on(appDealerDetailActions.LoadSalesConsultantFailAction, (state, { error }) => ({...state, salesConsultant: []})),
  on(appDealerDetailActions.SelectWriteupsCustomViewAction, (state, { payload }) => selectWriteupsCustomView(state, payload)),
);

export function loadCustomView(state: AuthAccessState, action : any) {
    let userDefinedDefaultview;
    if (action != undefined)
        {userDefinedDefaultview = action.views?.filter((view) => view.default);}
    if (userDefinedDefaultview && userDefinedDefaultview.length > 0)
        {state.defaultView[0].default = false;}
    else {
        state.defaultView[0].default = true;
        if (action && action["views"] === undefined)
            {action["views"] = [];}
        if (action && action["teams"] === undefined)
            {action["teams"] = [];}
    }
    state.defaultView[0].selected = undefined;
    state.myTeams = action["teams"] === undefined ? [] : action["teams"];
    state.logView = action["logView"] === undefined ? [] : action["logView"];
    state.darkTheme = action['darkTheme'];
    return {
        ...state,
        customViews: [...state.defaultView, ...action["views"]],
    };
}

export function loadSalesConsultant(state: AuthAccessState, action : any) {
    let salesCon;
    if (action && action != undefined && action.length > 0) {
        salesCon = [];
        action.map((sales) => {
            if (sales) {
                salesCon.push(`${sales.firstName  } ${  sales.lastName}`);
            }
        });
    } else {
        salesCon = [];
    }
    return { ...state, salesConsultant: salesCon, salesConsultantResponse: action || [] };
}

function selectWriteupsCustomView(state: AuthAccessState, action): AuthAccessState{
    let customViews = state?.customViews;
    customViews = customViews.map(view =>{
        if(view.forSection == 'writeup'){
            if(view.viewName?.toLowerCase() == action?.toLowerCase()) {view['selected'] = true;}
            else {view['selected'] = false;}
        }
        return view;
    });
    return { ...state, customViews: [...customViews] };
}